import request from "@/api";
import { BaseService } from "@/api/services/baseService";
import type { SpecialZoneAccountVo, Page, SpecialZoneAccount } from "@zhihaoscm/entity";
export class accountService extends BaseService<unknown, unknown, unknown, unknown> {
    // 专区余额管理-账户查询列表
    public async paging(params: any): Promise<Page<SpecialZoneAccountVo>> {
        const { data } = await this.service.get(`${this.path}/paging`, { params });
        return data;
    }

    // 专区余额管理-主体下拉
    public async selectorList(params: { keyword?: string }): Promise<any[]> {
        const { data } = await this.service.get(`${this.path}/selector`, { params });
        return data;
    }
    // 专区下拉搜索
    public async zoneSelector(params: { customerId: number; zoneName: string }): Promise<any[]> {
        const { data } = await this.service.get(`${this.path}/zone-selector`, { params });
        return data;
    }

    //用户和专区id查询余额账户
    public async findByUk(params: { customerId: number; zoneId: number }): Promise<SpecialZoneAccount> {
        const { data } = await this.service.get(`${this.path}/find-by-uk`, { params });
        return data;
    }
}
export const zoneAccountService = new accountService("/admin/special-zone-account", request.service);
